import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import * as _moment from 'moment';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { openExportDialog } from '../../tools/export-modal/export-modal.component';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY/MM",
  },
  display: {
    dateInput: "YYYY/MM",
    monthYearLabel: "YYYY/MM",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "YYYY/MMMM",
  },
};

@Component({
  selector: 'app-inventory-report',
  templateUrl: './inventory-report.component.html',
  styleUrls: ['./inventory-report.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class InventoryReportComponent {
  date = new Date();
  startDate = new UntypedFormControl(this.tools.FormatStartDate(new Date(this.date.getFullYear(), this.date.getMonth(), 1).toString()));
  endDate = new UntypedFormControl(this.tools.FormatEndDate(this.date.toString()));

  monthSelector = new UntypedFormControl(moment().startOf('month'));
  maxMonth = moment();

  downloading = false;

  constructor(
    private endpoints: Endpoints,
    private auth: UserRightsService,
    private genericService: GenericService,
    private tools: ToolsService,
    private _location: Location,
    private dialogRef: MatDialog,
  ) {}

  chosenMonthHandler(normalizedMonth, datepicker) {
    datepicker.close();
    const ctrlValue = this.monthSelector.value;
    ctrlValue.month(normalizedMonth.month());
    this.monthSelector.setValue(ctrlValue);
  }

  exportReport() {
    const obj = {
      InventoryDate: this.tools.FormatStartDate(this.monthSelector.value),
      AllDevices: false,
      AllDeviceTypes: true,
      DeviceIds: [],
      SimIds: [],
      DeviceTypes: [],
      CustomerIds: [],
      AggregateIds: [],
      DeviceSearchTerm: '',
      CustomerSearchTerm: '',
      AggregateSearchTerm: '',
      SimSearchTerm: '',
    };

    openExportDialog(this.dialogRef, {
      endpoint: this.endpoints.DOWNLOAD_INVENTORY_REPORT,
      reqObj: obj,
    });
  }

  cancel() {
    this._location.back();
  }
}
